var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaLoadBalancerDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic load balancer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 20H4C2.343 20 1 18.657 1 17V7C1 5.343 2.343 4 4 4H9C10.657 4 12 5.343 12 7V17C12 18.657 10.657 20 9 20Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21 9H19C17.895 9 17 8.105 17 7V5C17 3.895 17.895 3 19 3H21C22.105 3 23 3.895 23 5V7C23 8.105 22.105 9 21 9Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21 20H19C17.895 20 17 19.105 17 18V16C17 14.895 17.895 14 19 14H21C22.105 14 23 14.895 23 16V18C23 19.105 22.105 20 21 20Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M17 7H16.5C15.948 7 15.5 7.449 15.5 8V15C15.5 15.551 15.948 16 16.5 16H17V18H16.5C14.846 18 13.5 16.654 13.5 15V12.5H12V10.5H13.5V8C13.5 6.346 14.846 5 16.5 5H17V7Z",
    fill: "url(#paint0_linear_9146_76360)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.5 9H4.5C3.672 9 3 8.329 3 7.5C3 6.671 3.672 6 4.5 6H8.5C9.328 6 10 6.671 10 7.5C10 8.329 9.328 9 8.5 9Z",
    fill: "url(#paint1_linear_9146_76360)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.5 13H4.5C3.672 13 3 12.329 3 11.5C3 10.671 3.672 10 4.5 10H8.5C9.328 10 10 10.671 10 11.5C10 12.329 9.328 13 8.5 13Z",
    fill: "url(#paint2_linear_9146_76360)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.5 18C7.32843 18 8 17.3284 8 16.5C8 15.6716 7.32843 15 6.5 15C5.67157 15 5 15.6716 5 16.5C5 17.3284 5.67157 18 6.5 18Z",
    fill: "url(#paint3_linear_9146_76360)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9146_76360",
    x1: 9.26667,
    y1: 7.29834,
    x2: 19.6773,
    y2: 10.6721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9146_76360",
    x1: -0.826667,
    y1: 6.53039,
    x2: 2.48364,
    y2: 13.0386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9146_76360",
    x1: -0.826667,
    y1: 10.5304,
    x2: 2.48364,
    y2: 17.0386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9146_76360",
    x1: 3.36,
    y1: 15.5304,
    x2: 7.39661,
    y2: 18.9316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLoadBalancerDark);
export default __webpack_public_path__ + "static/media/figma-load-balancer-dark.41e27fbbd13d81b2aa2cb332055069f6.svg";
export { ForwardRef as ReactComponent };